$(window).load(function () {
    scrollClass('header', 'header', 'fixed');
});
